import configure from "configure"
import moment from "moment"
import React from "react"
import { getInitials } from "utils/common-helpers"

export const leaveColumns = (onLeaveDetail) => [
    {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center lemp-id",
    },
    {
        Header: "Employee Name",
        accessor: "name",
        isInfoIcon: false,
        isShortIcon: true,
        className: "col-md-3",
    },
    {
        Header: "Applied On",
        accessor: "created_at",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center lapplied_on_box",
        Cell: cellProps => {
            return (
                <div>{moment(cellProps?.row?.original.created_at).format('DD-MM-YYYY')}</div>
            )
        }
    },
    {
        Header: "Reason",
        accessor: "leave_reason",
        isInfoIcon: false,
        isShortIcon: true,
        className: "lreason_box text-start",
    },
    {
        Header: "End Date",
        accessor: "end_date",
        isInfoIcon: false,
        isShortIcon: true,
        className: "lemployee_code-box text-center",
    },
    {
        Header: "Total Days",
        accessor: "leave_days",
        isInfoIcon: false,
        isShortIcon: true,
        className: "lemployee_code-box text-center",
    },

    {
        Header: "Action",
        accessor: "action",
        Cell: cellProps => {
            return (
                <div className="d-flex">
                    <a
                        title="View"
                        className="btn btn-sm btn-outline-secondary me-1"
                        onClick={() => onLeaveDetail(cellProps?.row?.original?.id, cellProps?.row?.original?.employee,cellProps?.row?.original)}
                    >
                        <i className="fas fa-eye "></i>
                    </a>
                </div>
            )
        },
    },

]

export const pastLeaveColumns = (onLeaveDetail) => [
    {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center lemp-id",
    },
    {
        Header: "Employee Name",
        accessor: "name",
        isInfoIcon: false,
        isShortIcon: true,
        className: "col-md-3",
    },
    {
        Header: "Applied On",
        accessor: "created_at",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center lapplied_on_box",
        Cell: cellProps => {
            return (
                <div>{moment(cellProps?.row?.original.created_at).format('DD-MM-YYYY')}</div>
            )
        }
    },
    {
        Header: "Reason",
        accessor: "leave_reason",
        isInfoIcon: false,
        isShortIcon: true,
        className: "lreason_box text-start",
    },
    {
        Header: "End Date",
        accessor: "end_date",
        isInfoIcon: false,
        isShortIcon: true,
        className: "lemployee_code-box text-center",
    },
    {
        Header: "Total Days",
        accessor: "leave_days",
        isInfoIcon: false,
        isShortIcon: true,
        className: "lemployee_code-box text-center",
    },

    {
        Header: "Action",
        accessor: "action",
        Cell: cellProps => {
            return (
                <div className="d-flex">
                    <a
                        title="View"
                        className="btn btn-sm btn-outline-secondary me-1"
                        onClick={() => onLeaveDetail(cellProps?.row?.original?.id, cellProps?.row?.original?.employee,cellProps?.row?.original)}
                    >
                        <i className="fas fa-eye "></i>
                    </a>
                </div>
            )
        },
    },

]

export const pendingLeaveColumns = () => [
  {
    Header: "ID",
    accessor: "id",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center lemp-id",
  },
  {
    Header: "Employee Name",
    accessor: "name",
    isInfoIcon: false,
    isShortIcon: true,
    className: "col-md-3",
    Cell: (cellProps) => {
      const row = cellProps.row.original;
      const rawAvatar =
        row?.avatar || row?.assignee_avatar || row?.staff_avatar;
      const avatar =
        rawAvatar && rawAvatar !== "null"
          ? `${configure.imgUrl}${rawAvatar}`
          : null;
      const name =
        row?.name || row?.staff_name || row?.alias_name || row?.title || "";
      return (
        <div className="d-flex gap-2 align-items-center">
          {avatar ? (
            <img
              src={avatar}
              alt="Avatar"
              className="img-fluid assignee-img ms-2"
              title={name}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = ZithasLogo;
              }}
            />
          ) : (
            <div className="defualt-img" title={name}>
              {getInitials(name)}
            </div>
          )}
          <span>{name}</span>
        </div>
      );
    },
  },
  {
    Header: "Designation",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center lapplied_on_box",
    Cell: (cellProps) => {
      return (
        <div>{cellProps?.row?.original.designation || "Default"}</div>
      );
    },
  },
  {
    Header: "Applied On",
    accessor: "created_at",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center lapplied_on_box",
    Cell: (cellProps) => {
      return (
        <div>
          {moment(cellProps?.row?.original.created_at).format("DD-MM-YYYY")}
        </div>
      );
    },
  },
  {
    Header: "Start Date",
    accessor: "start_date",
    isInfoIcon: false,
    isShortIcon: true,
    className: "lemployee_code-box text-center",
  },
  {
    Header: "End Date",
    accessor: "end_date",
    isInfoIcon: false,
    isShortIcon: true,
    className: "lemployee_code-box text-center",
  },
  {
    Header: "Total Days",
    accessor: "leave_days",
    isInfoIcon: false,
    isShortIcon: true,
    className: "lemployee_code-box text-center",
  },
];